import { render, staticRenderFns } from "./RvtUvMapDialog.vue?vue&type=template&id=79f07f8d&scoped=true"
import script from "./RvtUvMapDialog.vue?vue&type=script&lang=js"
export * from "./RvtUvMapDialog.vue?vue&type=script&lang=js"
import style0 from "./RvtUvMapDialog.vue?vue&type=style&index=0&id=79f07f8d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f07f8d",
  null
  
)

export default component.exports